// import mediaQuery from './match-media';

export default function adminTweaks() {
    const adminBar = document.getElementById('wpadminbar');
    console.log('admin tweaks');

    if(! adminBar) {
        return;
    }

    const menuGlobalContainer = document.getElementById('menuGlobalContainer');

    if(! menuGlobalContainer) {
        return;
    }

   // menuGlobalContainer.style.top = `${adminBar.offsetHeight}px`;


}
